import { NCA_MAP_URL } from '@constants';
import { LatLngBounds } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import React from 'react';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';

import EmptyState from './EmptyState';
import { MapPropsInterface } from './MapContainerType';
import { validLocation } from './MonitoringMapContants';
import LocationMarkers from './LocationMarkers';
import { Routing } from './Routing';

function MonitoringMap({ markers }: MapPropsInterface) {
  if (!markers) {
    return <EmptyState />;
  }

  const { origin, destination, lastLocation, occurrencesLocation, journeyId } =
    markers;

  const hasOriginOrDestination =
    validLocation(origin) || validLocation(destination);

  function getBounds() {
    const bounds = new LatLngBounds([]);

    if (lastLocation && validLocation(lastLocation)) {
      bounds.extend([lastLocation.lat, lastLocation.lon]);
    }

    if (hasOriginOrDestination) {
      if (validLocation(origin)) {
        bounds.extend([origin.lat, origin.lon]);
      }
      if (validLocation(destination)) {
        bounds.extend([destination.lat, destination.lon]);
      }
    }

    return bounds;
  }

  const bounds = getBounds();

  function renderMap() {
    return (
      <MapContainer
        bounds={bounds.isValid() ? bounds : undefined}
        zoom={hasOriginOrDestination ? undefined : 6}
        attributionControl={false}
        zoomControl={false}
        scrollWheelZoom
        className="map"
      >
        <TileLayer
          url={`${NCA_MAP_URL}styles/journeys/{z}/{x}/{y}.png`}
          maxZoom={16}
          minZoom={4}
        />
        <LocationMarkers
          origin={origin}
          destination={destination}
          lastLocation={lastLocation}
          occurrencesLocation={occurrencesLocation}
          journeyId={journeyId}
        />
        <Routing
          origin={origin}
          destination={destination}
          journeyId={journeyId}
        />
        <ZoomControl position="topright" />
      </MapContainer>
    );
  }

  return <>{renderMap()}</>;
}

export default MonitoringMap;
